import React from 'react';
import Choropleth from '@splunk/dashboard-visualizations/Choropleth';
import GeoRegistry from '@splunk/visualization-context/GeoRegistry';
import GeoJsonProvider from '@splunk/visualization-context/GeoJsonProvider';
import { GeoContextProvider } from '@splunk/visualization-context/GeoContext';

const geoRegistry = GeoRegistry.create();
geoRegistry.addDefaultProvider(new GeoJsonProvider());

const ChoroplethProps = {
    mode: '',
    style: {},
    loading: false,
    width: 800,
    height: 600,
    onOptionsChange: () => {},
    onEventTrigger: () => {},
    onRequestParamsChange: () => {},
    options: {
        name: 'USA',
        source: 'geo://default/us',
        projection: 'mercator',
        sourceBounds: { lat: { min: 24, max: 50 }, long: { min: -130, max: -60 } },
        logicalBounds: { x: { min: 0, max: 800 }, y: { min: 0, max: 600 } },
        fillColor: '#EAEFF2',
        strokeColor: '#689C8D',
        strokeHighlightColor: '#000000',
        selector: '.feature',
    },
    encoding: {},
};

export default () => (
    <GeoContextProvider value={geoRegistry}>
        <Choropleth {...ChoroplethProps} />
    </GeoContextProvider>
);
